import apiClient from './apiClient'

/**
 * Get article linking for articles ids
 * @param {array} ids 
 * @returns 
 */
export const getArticleLink = async (ids) => await apiClient.get('/api/ArticleLink', { ids })